
import { Component } from '@angular/core';

@Component({
  selector: 'app-all-directory',
  templateUrl: './all-directory.component.html'
})
export class AllDirectoryComponent {


}